import React from 'react';
import { hot } from 'react-hot-loader';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { compose } from 'recompose';
import {
    Dimmer,
    Divider,
    Input,
    List,
    Loader,
    Table,
    Transition
} from 'semantic-ui-react';
import styled from 'styled-components';

import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList } from 'react-window';

import { withLocale } from 'op/components/locale';
import { withOnlineStatus } from 'op/components/offline';

import StpBlack from '../../../assets/stp-black.svg';
import { withSearchFiltering, withFormItems } from './forms-items.helper'

const Search = styled(Input)`
	width: 100%;
	border: 0;
`;

const StyledPage = styled.div`
	min-height: calc(100vh - 150px);
`;

const StyledPartialLoaderContainer = styled.div`
	position: absolute;
	width: 100%;
`;

const ActionBar = styled.div`
	display: inline;
  position: fixed;
  top: calc(100vh - 20px - 4em);
  ${props => props.direction || 'right'}: 20px;
  z-index: 3000;
  -webkit-backface-visibility: hidden;
`;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #ddd;
    margin-bottom: 1em;
    thead {
        background-color: #f2f2f2;
        tr {
            th {
                padding: 0.5em;
                text-align: left;
            }
        }
    }
    tbody {
        tr {
            td {
                padding: 0.5em;
                border-top: 1px solid #ddd;
                background-color: #fff;
                border-left: 1px solid #ddd;
            }
        }
    }
`;


const StpItems = ({ loading, locale, search, setSearch, items, online, ...props }) => {
    const history = useHistory();


    return (
        <StyledPage>
            <Search placeholder={locale.searchbar}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
            <Divider />
            <StyledPartialLoaderContainer>
                <Transition.Group animation={'fly down'} duration={200}>
                    {loading == 'partial' && <Loader size='small' inline='centered' />}
                </Transition.Group>
            </StyledPartialLoaderContainer>
            <Dimmer active={loading == 'full'}><Loader active /></Dimmer>
            <StyledTable>
                <thead>
                    <tr>
                        <th>{locale.name}</th>
                        <th>{locale.serial}</th>
                        <th>{locale.model}</th>
                        <th>{locale.location}</th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((item) => (<tr key={item.ASM_Item_ID + Math.random()}>
                        <td>
                            <Link to={`/forms/${item.ASM_Item_ID}/records`}>{item.ASM_Item_Name}</Link>
                        </td>
                        <td>
                            {item.ASM_Item_Serial}
                        </td>
                        <td>
                            {item.ASM_Item_Model}
                        </td>
                        <td>
                            {item.ASM_Item_Location}
                        </td>
                    </tr>))}
                </tbody>
            </StyledTable>
        </StyledPage>
    );
}

export default compose(
    withLocale('stp.search'),
    withFormItems,
    withSearchFiltering,
    withOnlineStatus,
    hot(module),
)(StpItems);
